import { defaultBgImgId } from 'src/consumer/constants'

export const getListItemsFromAssessmentList = (assessmentsList) => {
  const listItemsArray = []
  assessmentsList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: `/assessment/${item?.slug}`,
    })
  })

  return listItemsArray
}

export const getListItemsFromJournalsList = (journalsList) => {
  const listItemsArray = []
  journalsList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: item?.slug ? `/journal/${item?.slug}` : `/journal/id/${item?.id}`,
    })
  })

  return listItemsArray
}

export const getListItemsFromCoursesList = (coursesList, category) => {
  const listItemsArray = []

  coursesList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverImage || item?.coverIcon || defaultBgImgId,
      link: item?.slug
        ? category === 'podcast'
          ? `/${category}/${item?.slug}`
          : `/c/${category}/${item?.slug}`
        : '/',
    })
  })

  return listItemsArray
}

export const getListItemsFromBreatheList = (breatheList) => {
  const listItemsArray = []
  breatheList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: `/`,
      // link: `/breathe/${item?.slug}`
    })
  })

  return listItemsArray
}

export const getListItemsFromTechniqueList = (techniqueList) => {
  const listItemsArray = []
  techniqueList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: `/technique/id/${item?.assessmentId}`,
    })
  })

  return listItemsArray
}

export const getListItemsFromActivityPlanList = (apList) => {
  const listItemsArray = []
  apList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: `${item?.slug}`,
      // link: `/technique/${item?.slug}`
    })
  })

  return listItemsArray
}

export const getListItemsFromArticlesList = (articlesList) => {
  const listItemsArray = []
  articlesList?.forEach((item) => {
    listItemsArray?.push({
      id: item?.assessmentId,
      slug: item?.slug,
      title: item?.title,
      description: item?.description,
      imageId: item?.coverIcon || defaultBgImgId,
      link: item?.slug ? `/article/${item?.slug}` : `/article/id/${item?.id}`,
    })
  })

  return listItemsArray
}
